import React from 'react'
import MainContentSmartWatch from './MainContentSmartWatch'


const LayoutSmartWatch = () => {
  return (
    <div className='page-smartWatch'>
        <MainContentSmartWatch />
    </div>
  )
}

export default LayoutSmartWatch
